import React from 'react';

export default function QuestionMark({ className = '', title }) {
  return (

    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M9.75 14.25H8.25V12.75H9.75V14.25ZM9.375 3.75C11.235 3.75 12.75 5.265 12.75 7.125C12.75 8.7825 11.2875 10.088 9.75 10.418V11.25H8.25V9H9C10.02 9 11.25 8.16 11.25 7.125C11.25 6.09 10.41 5.25 9.375 5.25C8.34 5.25 7.5 6.09 7.5 7.125H6C6 5.265 7.515 3.75 9.375 3.75Z"
        fill="currentColor"
      />
      <path
        d="M9 0C13.965 0 18 4.035 18 9C18 13.965 13.965 18 9 18C4.035 18 0 13.965 0 9C0 4.035 4.035 0 9 0ZM9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5Z"
        fill="currentColor"
      />
    </svg>

  );
}

